import { useStore } from "vuex"
import { ref, onMounted, watch, computed } from "vue"

const ACTIVE_STEP_CLASS = "kb-hero-general__step-indicator-circle--active-step"

export default {
    name: "PersonalFundraisingFlowStepHero",
    setup() {
        const store = useStore()
        
        const stepWrapper = ref(null)
        const steps = ref([])
        const currentStepIndex = ref(null)
        const storeStep = computed(() => store.state.fundraising.personalFundraisingFlowStep)

        watch(storeStep, (newStepNumber) => {
            if (!steps.value.length) return

            const newStepIndex = newStepNumber - 1
            const newStep = steps.value[newStepIndex]
            const newStepCircleElement = newStep ? getCircleElement(newStep) : null

            if (newStepCircleElement) {
                newStepCircleElement.classList.add(ACTIVE_STEP_CLASS)
            }

            if (currentStepIndex.value !== null) {
                const previousStep = steps.value[currentStepIndex.value]
                const previousStepCircleElement = previousStep
                    ? getCircleElement(previousStep)
                    : null

                if (previousStepCircleElement) {
                    previousStepCircleElement.classList.remove(ACTIVE_STEP_CLASS)
                }
            }

            currentStepIndex.value = newStepIndex
        })

        const getCircleElement = (step) => {
            return step.querySelector(".kb-hero-general__step-indicator-circle")
        }

        onMounted(() => {
            if (!stepWrapper.value) return

            steps.value = Array.from(stepWrapper.value.children)
            currentStepIndex.value = steps.value.findIndex(
                (step) => step.getAttribute("aria-current") === "step"
            )
        })

        return {
            stepWrapper
        }
    }
}